export default __webpack_public_path__ + "static/spotify-image-00d9ed6dad45c8ad9a6a5032adfe7aa9.jpg";